export const DICTIONARY_HIGHLIGHT_BLOT_NAME = 'dictionaryHighlight'
export const DICTIONARY_HIGHLIGHT_TAG_NAME = 'span'
export const DICTIONARY_HIGHLIGHT_CLASS_NAME = 'dictionary-highlight'
export const DICTIONARY_HIGHLIGHT_MODULE_NAME = 'dictionaryHighlightModule'


export const CLONED_CONTENTS_CLASS_NAME = 'cloned-contents'
export const REGISTERED_WORD_CLASS_NAME = 'registered'
export const SELECTED_WORD_CLASS_NAME = 'selected'